export default __webpack_public_path__ + "static/media/s5.4403e508.jpg";